module.exports = __webpack_public_path__ + "static/favicon-f32725272653652c3cfd83759ad6fd72.ico";